"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var context_1 = __importDefault(require("../../contexts/rubyJackpot/context"));
var App_1 = __importDefault(require("./App/App"));
var dispatcher = new eventemitter3_1.default();
var RubyJackpotWidget = function (_a) {
    var features = _a.features, lang = _a.lang, currency = _a.currency;
    return ((0, jsx_runtime_1.jsx)(context_1.default, { children: (0, jsx_runtime_1.jsx)(App_1.default, { currency: currency, features: features, lang: lang, dispatcher: dispatcher }) }));
};
exports.default = RubyJackpotWidget;
